import React from 'react';
import { FadeIn } from '../animations/FadeIn';
import { WaveGraphic } from '../graphics/WaveGraphic';
import SafeIcon from '../../common/SafeIcon';

export const CTA = () => {
  return (
    <section id="download" className="py-24 bg-paper px-6">
      <div className="max-w-5xl mx-auto bg-ink rounded-[40px] relative overflow-hidden py-20 px-8 text-center">
        <WaveGraphic className="top-0 left-0 opacity-50" />
        
        <div className="relative z-10 max-w-2xl mx-auto">
          <FadeIn>
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/5 border border-white/10 text-mint text-xs font-bold tracking-widest uppercase mb-6">
              Get Notified
            </div>
            <h2 className="text-4xl md:text-5xl font-semibold text-white tracking-tight mb-6">
              Be the first to know.
            </h2>
            <p className="text-lg text-white/70 font-light mb-10">
              Join our waitlist to get early access to Curve and start taking control of your GLP-1 routine.
            </p>
            
            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <div className="relative">
                <button className="flex items-center justify-center gap-3 bg-white/10 text-white/40 px-8 py-4 rounded-full font-semibold cursor-not-allowed border border-white/10 text-lg">
                  <SafeIcon name="Apple" className="text-2xl" />
                  App Store
                </button>
                <span className="absolute -top-2 -right-2 bg-mint text-ink text-[10px] font-bold px-2 py-0.5 rounded-full">COMING SOON</span>
              </div>
              <div className="relative">
                <button className="flex items-center justify-center gap-3 bg-white/10 text-white/40 px-8 py-4 rounded-full font-semibold cursor-not-allowed border border-white/10 text-lg">
                  <SafeIcon name="Play" className="text-2xl" />
                  Google Play
                </button>
                <span className="absolute -top-2 -right-2 bg-sky text-ink text-[10px] font-bold px-2 py-0.5 rounded-full">COMING SOON</span>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>
  );
};